import React, { useState, useEffect, useRef } from "react";
import FeatherIcon from "feather-icons-react";
import { formInputErrorMsg } from "./empConstants";

function EMPText(props) {
  const {
    label,
    isRequired,
    errId,
    divClass,
    fieldName,
    handleTextChange,
    checkDetailsIndex,
    fieldValue,
    hasError = null,
    isDisabled = false,
    countryCodeOptions = [],
    countryCodeValue = "",
    handleCountryCode,
    note,
    dataTip = ""
  } = props;
  let elementClass = "col-sm-4 col-md-12 col-xl-4";
  if (divClass) {
    elementClass = divClass;
  }

  const handleOnChange = (e) => {
    handleTextChange(e.target);
  };

  const errorMsg =
    (fieldValue == null || fieldValue == "") && isRequired == 1
      ? formInputErrorMsg.requiredError
      : formInputErrorMsg.InvalidError;
  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          <div
            className={
              [
                "manager_mobile_no",
                "manager_mobile_no1",
                "hr_mobile_no",
              ].includes(fieldName)
                ? "floating-label has-country-code"
                : "floating-label"
            }
          >
            {[
              "manager_mobile_no",
              "manager_mobile_no1",
              "hr_mobile_no",
            ].includes(fieldName) ? (
              <>
                <select
                  name={fieldName}
                  className={
                    countryCodeValue.toString().length === 3
                      ? "three-digit"
                      : countryCodeValue.toString().length === 2
                      ? "two-digit"
                      : "one-digit"
                  }
                  data-checkdetailsindex={checkDetailsIndex}
                  data-fieldname={fieldName}
                  onChange={handleCountryCode}
                  // style={{
                  //   width:
                  //     countryCodeValue.toString().length === 3
                  //       ? "68px"
                  //       : countryCodeValue.toString().length === 2
                  //       ? "58px"
                  //       : "49px",
                  // }}
                >
                  {countryCodeOptions?.map((option) => {
                    return (
                      <option
                        value={option.label.value}
                        selected={
                          countryCodeValue == option.label.value ? true : false
                        }
                      >
                        {`${option.label.text} (${option.label["data-subtext"]})`}
                      </option>
                    );
                  })}
                </select>
                <input
                  type="text"
                  className="form-control"
                  value={fieldValue}
                  id={errId}
                  onChange={(e) => handleOnChange(e)}
                  data-checkdetailsindex={checkDetailsIndex}
                  data-fieldname={fieldName}
                  disabled={isDisabled}
                />
              </>
            ) : (
              <>
               <input
                type="text"
                className="form-control"
                value={fieldValue}
                id={errId}
                onChange={(e) => handleOnChange(e)}
                data-checkdetailsindex={checkDetailsIndex}
                data-fieldname={fieldName}
                disabled={isDisabled}
              />
              {
                dataTip && <span title={dataTip} ><FeatherIcon icon="info" 
                style={{height: 16, width: 16,  position: "absolute",
                  top: "15px",
                  right: "12px",}}/></span>
              }
              </>
            )}

            <label htmlFor={errId} className={fieldValue && "focused"}>
              {label}
              {isRequired == 1 && <sup className="text-danger">*</sup>}
            </label>
          </div>{
            note && note== true &&(
              <p><small>We use the SSN only for the employment Verification Purpose </small></p>
            )
          }
          {hasError && hasError == true && (
            <p className="err text-danger" id={errId}>
              {errorMsg}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default EMPText;
